import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('main');
  const [showAuthorCard, setShowAuthorCard] = useState(false);
  const [showSecretPage, setShowSecretPage] = useState(false);
  const [showPasswordPrompt, setShowPasswordPrompt] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showAuthor, setShowAuthor] = useState(true);
  const [showFunnyPage, setShowFunnyPage] = useState(false);

  const complimentsData = [
    { id: 1, photo: '/images/kira1.JPG', text: 'В тебе есть что-то неуловимое и прекрасное' },
    { id: 2, photo: '/images/kira2.JPG', text: 'Ты умеешь видеть то, что другие не замечают' },
    { id: 3, photo: '/images/kira3.JPG', text: 'Твоё присутствие делает всё вокруг легче' },
    { id: 4, photo: '/images/kira4.JPG', text: 'Ты не боишься быть разной — и это честно' },
    { id: 5, photo: '/images/kira5.JPG', text: 'Ты умеешь создавать красоту из простых вещей' },
    { id: 6, photo: '/images/kira6.JPG', text: 'С тобой даже тишина звучит иначе' },
    { id: 7, photo: '/images/kira7.JPG', text: 'Ты остаёшься собой, что бы ни случилось' },
    { id: 8, photo: '/images/kira8.JPG', text: 'Твоя энергия чувствуется на расстоянии' },
    { id: 9, photo: '/images/kira9.JPG', text: 'Ты умеешь слышать больше, чем говорят' },
    { id: 10, photo: '/images/kira10.JPG', text: 'Твои мысли всегда глубже, чем кажется' },
    { id: 11, photo: '/images/kira11.JPG', text: 'Ты приносишь свет туда, где его не хватает' },
    { id: 12, photo: '/images/kira12.JPG', text: 'Ты — человек, на которого можно положиться' },
    { id: 13, photo: '/images/kira13.JPG', text: 'Ты делаешь этот мир интереснее' },
    { id: 14, photo: '/images/kira14.JPG', text: 'В тебе есть глубина и лёгкость одновременно' },
    { id: 15, photo: '/images/kira15.JPG', text: 'Просто будь. Этого достаточно' },
  ];

  const funnyData = [
    { id: 1, photo: '/images/funny/1.jpg', title: 'Кому подмигиваешь?', description: '' },
    { id: 2, photo: '/images/funny/2.jpg', title: 'Немножко монашка', description: '' },
    { id: 3, photo: '/images/funny/3.jpg', title: 'Ну красотка', description: '' },
    { id: 4, photo: '/images/funny/4.jpg', title: 'Чуть-чуть и позлиться можно', description: '' },
    { id: 5, photo: '/images/funny/5.jpg', title: 'Не трогаем, сосредоточена', description: '' },
    { id: 6, photo: '/images/funny/6.jpg', title: 'Майк Тайсон нервно курит в сторонке', description: '' },
  ];

  const storyData = [
    { id: 1, date: 'Март 2024', title: 'Первая встреча в Москве', text: 'В тот день я ехал часов 5-6 чтобы побыть с тобой, ради тебя готов на очень многое', photo: '/images/story/1.jpg' },
    { id: 2, date: 'Август 2024', title: 'Особенный момент', text: 'Здесь мы соединили наши половинки в одно сердечко и запустили в небо, НАВСЕГДА', photo: '/images/story/2.jpg' },
    { id: 3, date: 'Август 2024', title: 'Антоша пригрустил', text: 'Уже не вспомню почему грустил, но это по-любому было не сильно (БЫЛ С ТОБОЙ)', photo: '/images/story/3.jpg' },
    { id: 4, date: 'Июнь 2024', title: 'Мой выпускной', text: 'Спасибо, что разделила этот праздник (Я вот на твой не факт, что успею приехать, но есть его вуз, уж там я тебя порадую)', photo: '/images/story/4.jpg' },
    { id: 5, date: 'Апрель 2024', title: 'Красивое вайбовое фото', text: 'Мне просто безумно нравится это фото', photo: '/images/story/5.jpg' },
    { id: 6, date: 'Май 2024', title: 'Счастлив', text: 'День вроде был обычным, но в тот день я был счастлив', photo: '/images/story/6.jpg' },
  ];

  const [currentComplimentIndex, setCurrentComplimentIndex] = useState(0);

  const nextPhoto = () => {
    setCurrentComplimentIndex((prev) => (prev + 1) % complimentsData.length);
  };

  const prevPhoto = () => {
    setCurrentComplimentIndex((prev) => (prev - 1 + complimentsData.length) % complimentsData.length);
  };

  const handleSecretPassword = () => {
    if (passwordInput === '0387') {
      setShowPasswordPrompt(false);
      setShowSecretPage(true);
      setShowAuthorCard(false);
      setPasswordInput('');
      setPasswordError('');
    } else {
      setPasswordError('Неверный пароль');
    }
  };

  // Страница со смешными кадрами
  if (showFunnyPage) {
    return (
      <motion.div 
        className="funny-page"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.button 
          className="back-btn"
          onClick={() => setShowFunnyPage(false)}
          whileHover={{ scale: 1.05, x: -5 }}
          whileTap={{ scale: 0.95 }}
        >
          ← На главную
        </motion.button>

        <motion.div 
          className="funny-header"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="funny-title">Лучшие кадры</h1>
          <div className="funny-subtitle">Эстетика эстетикой, а про такие кадры не забываем</div>
        </motion.div>

        <motion.div 
          className="funny-grid"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {funnyData.map((item, index) => (
            <motion.div 
              key={item.id}
              className="funny-card"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className="funny-card-photo">
                <img src={item.photo} alt={item.title} onError={(e) => { e.target.src = 'https://via.placeholder.com/300?text=📸'; }} />
              </div>
              <div className="funny-card-title">{item.title}</div>
              <div className="funny-card-desc">{item.description}</div>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    );
  }

  if (showSecretPage) {
    return (
      <motion.div 
        className="secret-page"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.button 
          className="back-btn"
          onClick={() => {
            setShowSecretPage(false);
            setCurrentPage('main');
          }}
          whileHover={{ scale: 1.05, x: -5 }}
          whileTap={{ scale: 0.95 }}
        >
          ← На главную
        </motion.button>

        <motion.div 
          className="secret-header"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="secret-title">Наша история</h1>
          <div className="secret-subtitle">6 важных моментов</div>
        </motion.div>

        <motion.div 
          className="story-grid"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {storyData.map((item, index) => (
            <motion.div 
              key={item.id}
              className="story-card"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -8, transition: { duration: 0.2 } }}
            >
              <div className="story-card-photo">
                <img src={item.photo} alt={item.title} onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }} />
                <div className="story-card-placeholder" style={{ display: 'none' }}>
                  <span>📸</span>
                </div>
              </div>
              <div className="story-card-date">{item.date}</div>
              <h3 className="story-card-title">{item.title}</h3>
              <p className="story-card-text">{item.text}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          className="couple-section"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="couple-container">
            <div className="couple-photo">
              <img src="/images/me-large.jpg" alt="Антоша" onError={(e) => { e.target.src = '/images/me.jpg'; }} />
              <div className="couple-label">Антоша</div>
            </div>
            
            <div className="thread-wrapper">
              <div className="thread-line"></div>
              <div className="thread-knot"></div>
              <div className="thread-text">связаны</div>
            </div>
            
            <div className="couple-photo">
              <img src="/images/kira-large.jpg" alt="Кирусик" onError={(e) => { e.target.src = '/images/kira.JPG'; }} />
              <div className="couple-label">Кира</div>
            </div>
          </div>
        </motion.div>

        <motion.div 
          className="timeline-years"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
        >
          <h3 className="years-title">Наш путь</h3>
          
          <div className="years-row">
            <div className="year-item">
              <div className="year-photo">
                <img src="/images/years/2022.jpg" alt="2022" onError={(e) => { e.target.src = 'https://via.placeholder.com/200?text=2022'; }} />
              </div>
              <div className="year-label">2022</div>
            </div>
            <div className="year-arrow">→</div>
            <div className="year-item">
              <div className="year-photo">
                <img src="/images/years/2023.jpg" alt="2023" onError={(e) => { e.target.src = 'https://via.placeholder.com/200?text=2023'; }} />
              </div>
              <div className="year-label">2023</div>
            </div>
            <div className="year-arrow">→</div>
            <div className="year-item">
              <div className="year-photo">
                <img src="/images/years/2024.jpg" alt="2024" onError={(e) => { e.target.src = 'https://via.placeholder.com/200?text=2024'; }} />
              </div>
              <div className="year-label">2024</div>
            </div>
          </div>

          <div className="years-row">
            <div className="year-item year-item-text">
              <div className="year-photo year-photo-text">
                <div className="year-text-overlay">
                  <span>А здесь мы</span>
                  <span>отдыхали друг</span>
                  <span>от друга</span>
                </div>
              </div>
              <div className="year-label">2025</div>
            </div>
            <div className="year-arrow">→</div>
            <div className="year-item">
              <div className="year-photo">
                <img src="/images/years/2026.jpg" alt="2026" onError={(e) => { e.target.src = 'https://via.placeholder.com/200?text=2026'; }} />
              </div>
              <div className="year-label">2026</div>
            </div>
          </div>
        </motion.div>

        <motion.div 
          className="chaos-gallery"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <h3 className="gallery-title">Наши моменты</h3>
          <div className="chaos-grid">
            <img src="/images/chaos/1.jpg" className="chaos-img chaos-img-1" alt="момент" onError={(e) => e.target.style.display = 'none'} />
            <img src="/images/chaos/2.jpg" className="chaos-img chaos-img-2" alt="момент" onError={(e) => e.target.style.display = 'none'} />
            <img src="/images/chaos/3.jpg" className="chaos-img chaos-img-3" alt="момент" onError={(e) => e.target.style.display = 'none'} />
            <img src="/images/chaos/4.jpg" className="chaos-img chaos-img-4" alt="момент" onError={(e) => e.target.style.display = 'none'} />
            <img src="/images/chaos/5.jpg" className="chaos-img chaos-img-5" alt="момент" onError={(e) => e.target.style.display = 'none'} />
            <img src="/images/chaos/6.jpg" className="chaos-img chaos-img-6" alt="момент" onError={(e) => e.target.style.display = 'none'} />
            <img src="/images/chaos/7.jpg" className="chaos-img chaos-img-7" alt="момент" onError={(e) => e.target.style.display = 'none'} />
            <img src="/images/chaos/8.jpg" className="chaos-img chaos-img-8" alt="момент" onError={(e) => e.target.style.display = 'none'} />
          </div>
        </motion.div>

        <motion.div 
          className="secret-footer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <p>Каждый день с тобой — новая страница</p>
        </motion.div>
      </motion.div>
    );
  }

  if (currentPage === 'admiration') {
    const current = complimentsData[currentComplimentIndex];
    return (
      <motion.div 
        className="admiration-page"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.button 
          className="back-btn"
          onClick={() => setCurrentPage('main')}
          whileHover={{ scale: 1.05, x: -5 }}
          whileTap={{ scale: 0.95 }}
        >
          На главную
        </motion.button>

        <div className="carousel-container">
          <motion.div
            key={current.id}
            initial={{ opacity: 0, scale: 0.8, rotateY: 90 }}
            animate={{ opacity: 1, scale: 1, rotateY: 0 }}
            transition={{ duration: 0.5 }}
            className="photo-card"
          >
            <img src={current.photo} alt="Кира" className="admiration-photo" />
          </motion.div>

          <motion.div 
            className="compliment-text"
            key={`text-${current.id}`}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            {current.text}
          </motion.div>

          <div className="carousel-buttons">
            <motion.button 
              onClick={prevPhoto} 
              className="nav-btn"
              whileHover={{ scale: 1.1, x: -3 }}
              whileTap={{ scale: 0.95 }}
            >
              ◀
            </motion.button>
            <motion.button 
              onClick={nextPhoto} 
              className="nav-btn"
              whileHover={{ scale: 1.1, x: 3 }}
              whileTap={{ scale: 0.95 }}
            >
              ▶
            </motion.button>
          </div>

          <div className="counter">
            {currentComplimentIndex + 1} / {complimentsData.length}
          </div>
        </div>
      </motion.div>
    );
  }

  return (
    <>
      <motion.div 
        className="main-page"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <div className="top-buttons">
          <motion.button 
            className="admire-btn"
            onClick={() => setCurrentPage('admiration')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            О тебе
          </motion.button>

          <motion.button 
            className="funny-btn"
            onClick={() => setShowFunnyPage(true)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Лучшие кадры
          </motion.button>
        </div>

        <motion.h1 
          className="title"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          Кира Кулакова
          <span className="subtitle">Это для тебя</span>
        </motion.h1>

        <motion.div 
          className="photo-container"
          initial={{ scale: 0, opacity: 0, rotate: -10 }}
          animate={{ scale: 1, opacity: 1, rotate: 0 }}
          transition={{ duration: 0.6, delay: 0.2, type: "spring" }}
        >
          <img src="/images/kira.JPG" alt="Кира" className="kira-photo" />
          <div className="photo-glow"></div>
        </motion.div>

        <motion.div 
          className="lovely-text"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <p>Совершенство — это не когда невозможно добавить что-то, а когда нечего убрать</p>
          <p className="quote-author">— Антуан де Сент-Экзюпери —</p>
        </motion.div>

        <div className="author-control">
          <motion.button 
            className="toggle-author-btn"
            onClick={() => setShowAuthor(!showAuthor)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {showAuthor ? 'Скрыть' : 'Показать'}
          </motion.button>
        </div>

        {showAuthor && (
          <motion.div 
            className="author-section"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            onClick={() => setShowAuthorCard(true)}
            whileHover={{ scale: 1.05 }}
          >
            <img src="/images/me.jpg" alt="Автор" className="author-photo" />
            <span className="author-name">Автор</span>
          </motion.div>
        )}
      </motion.div>

      <AnimatePresence>
        {showAuthorCard && (
          <motion.div 
            className="author-card-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowAuthorCard(false)}
          >
            <motion.div 
              className="author-card"
              initial={{ scale: 0.5, opacity: 0, y: 50 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.5, opacity: 0, y: 50 }}
              transition={{ type: "spring", damping: 20 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-card" onClick={() => setShowAuthorCard(false)}>✕</button>
              <img src="/images/me.jpg" alt="Антоша" className="author-full-photo" />
              <h2 className="author-card-name">Антоша</h2>
              
              <motion.button 
                className="secret-card-btn"
                onClick={() => {
                  setShowAuthorCard(false);
                  setShowPasswordPrompt(true);
                }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Секретная кнопка
              </motion.button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showPasswordPrompt && (
          <motion.div 
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => {
              setShowPasswordPrompt(false);
              setPasswordError('');
              setPasswordInput('');
            }}
          >
            <motion.div 
              className="modal-content"
              initial={{ scale: 0.8, opacity: 0, y: -50 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.8, opacity: 0, y: -50 }}
              onClick={(e) => e.stopPropagation()}
            >
              <h3>Секретная страница</h3>
              <p>Введите пароль, чтобы продолжить</p>
              <input 
                type="password" 
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
                placeholder="0000"
                onKeyPress={(e) => e.key === 'Enter' && handleSecretPassword()}
                autoFocus
              />
              {passwordError && <p className="error">{passwordError}</p>}
              <div className="modal-buttons">
                <button onClick={() => {
                  setShowPasswordPrompt(false);
                  setPasswordError('');
                  setPasswordInput('');
                }}>Отмена</button>
                <button onClick={handleSecretPassword}>Открыть</button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default App;